import { createFileRoute } from "@tanstack/react-router";
import { Mail, Phone, MessageSquare, Clock, MapPin } from "lucide-react";
import { EMAIL, PHONE, TEL, SMS } from "@/components/site-chrome";
import { RequestService } from "@/components/request-service";
import { PageHero, TownChips } from "@/components/sections";
import { resolveServiceParam } from "@/lib/services-data";
import { pageHead, breadcrumbLd } from "@/lib/seo";

const TITLE = "Contact 406 Mobile Mechanic | Great Falls MT Mobile Mechanic";
const DESC = "Call or text 406-799-0095 or send a service request to 406 Mobile Mechanic in Great Falls, MT. Open 7 days, 8AM–9PM.";

export const Route = createFileRoute("/contact")({
  validateSearch: (s: Record<string, unknown>): { service?: string } => (typeof s["service"] === "string" ? { service: s["service"] } : {}),
  head: () => pageHead("/contact", TITLE, DESC, [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }])]),
  component: ContactPage,
});

function ContactPage() {
  const { service } = Route.useSearch();
  const pre = resolveServiceParam(service);
  return (
    <main>
      <PageHero
        crumbs={[{ label: "Home", to: "/" }, { label: "Contact" }]}
        title={<>Contact Your Mobile Mechanic in <span className="text-primary">Great Falls, MT</span></>}
        intro="Broken down right now? Call or text 406-799-0095. For anything that can wait, send a request below and Josh will get back to you."
        photo="lettering"
      />
      <section className="bg-background py-16">
        <div className="mx-auto grid max-w-7xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-4">
          <a href={TEL} className="rounded-sm border border-border bg-card p-6 hover:border-primary"><Phone className="h-6 w-6 text-primary" aria-hidden /><p className="label-mono mt-3 text-steel">Call</p><p className="font-display text-2xl font-bold">{PHONE}</p></a>
          <a href={SMS} className="rounded-sm border border-border bg-card p-6 hover:border-primary"><MessageSquare className="h-6 w-6 text-primary" aria-hidden /><p className="label-mono mt-3 text-steel">Text</p><p className="font-display text-2xl font-bold">{PHONE}</p></a>
          <a href={`mailto:${EMAIL}`} className="rounded-sm border border-border bg-card p-6 hover:border-primary"><Mail className="h-6 w-6 text-primary" aria-hidden /><p className="label-mono mt-3 text-steel">Email</p><p className="break-all font-semibold">{EMAIL}</p></a>
          <div className="rounded-sm border border-border bg-card p-6"><Clock className="h-6 w-6 text-primary" aria-hidden /><p className="label-mono mt-3 text-steel">Hours</p><p className="font-display text-2xl font-bold">Mon–Sun · 8 AM – 9 PM</p></div>
        </div>
        <div className="mx-auto mt-10 max-w-7xl px-4 sm:px-6">
          <p className="label-mono flex items-center gap-2 text-primary"><MapPin className="h-4 w-4" aria-hidden />Service area</p>
          <TownChips />
        </div>
      </section>
      <RequestService key={pre} defaultService={pre} />
    </main>
  );
}
